import { Grid } from '@mui/material';
import { map, size } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import CustomCard2 from '../../components/cards/CustomCard2';
import BrandsSidebar from '../../components/sidebars/BrandsSidebar';
import BrandWidget2 from '../../components/widgets/BrandWidget2';
import PageLayout from '../layouts/PageLayout';
import CountBadge from '../../components/CountBadge';

// !############### MAIN FUNC ####################
const Brands = () => {
    const brands = useSelector((state) => state.brands.brands);

    return (
        <>
            <PageLayout
                sidebar={<BrandsSidebar brands={brands} />}
                head="Brands managements"
            >
                <CustomCard2
                    title={`CAICA Brands`}
                    height={640}
                    action={
                        <CountBadge
                            total={size(brands)}
                            item={'Brands'}
                        />
                    }
                >
                    <Grid container padding={2} spacing={3}>
                        {map(brands, (brand) => (
                            <Grid item sm={4} key={brand.id}>
                                <BrandWidget2 brand={brand} />
                            </Grid>
                        ))}
                    </Grid>
                </CustomCard2>
            </PageLayout>
        </>
    );
};

export default Brands;
